// One shared file for Phase 2 placeholder screens so the sidebar never 404s.
import { Bot, Zap, Star, FileText, CreditCard, BarChart3 } from "lucide-react";
import ComingSoon from "@/pages/ComingSoon";

export const AIEmployees = () => (
  <ComingSoon
    title="AI Employees"
    description="Create configurable AI teammates for every job: sales, support, appointments, reviews, SEO."
    icon={Bot} color="orange"
    features={[
      "Sales AI — qualifies leads and books meetings",
      "Support AI — resolves patient/customer questions",
      "Appointment AI — schedules & confirms",
      "Review AI — asks for reviews at the right moment",
      "Marketing AI — drafts posts and campaigns",
      "SEO AI — writes titles, descriptions, alt text",
      "Per-employee system prompt, model, temperature, tone",
      "Escalation rules — hand off to a human anytime",
    ]}
  />
);

export const Automation = () => (
  <ComingSoon
    title="Automation"
    description="Visual workflows — if this, then that — powered by your leads, forms, AI, and integrations."
    icon={Zap} color="orange"
    features={[
      "Trigger: new lead / form / message / review",
      "Actions: SMS, Email, AI reply, CRM update, task, webhook",
      "Multi-step branching with conditions",
      "Templates for common flows (welcome sequence, missed-call text-back)",
      "Run history + error logs",
    ]}
  />
);

export const Reviews = () => (
  <ComingSoon
    title="Reviews"
    description="Collect, respond, and showcase reviews from Google, Yelp, and your own site — in one inbox."
    icon={Star} color="orange"
    features={[
      "Google Business Profile sync",
      "Auto-respond with AI",
      "Automated review requests via SMS/email",
      "Public gallery block for your site",
      "Sentiment analysis + monthly report",
    ]}
  />
);

export const Forms = () => (
  <ComingSoon
    title="Forms"
    description="Build custom lead-capture and intake forms. Data flows straight into CRM + Message Center."
    icon={FileText} color="blue"
    features={[
      "Drag-and-drop form builder",
      "Custom fields (text, email, phone, dropdown, file upload)",
      "Multi-step forms with logic",
      "Embed anywhere on your website (block library integration)",
      "Auto-tag submissions with source & UTM",
    ]}
  />
);

export const Billing = () => (
  <ComingSoon
    title="Billing"
    description="Stripe-powered subscriptions, invoices, and revenue tracking per tenant."
    icon={CreditCard} color="green"
    features={[
      "Stripe subscription plans per tenant",
      "One-time invoices & receipts",
      "Usage-based add-ons (AI credits, SMS volume)",
      "Failed-payment retry + dunning emails",
      "Revenue analytics in Master Dashboard",
    ]}
  />
);

export const Analytics = () => (
  <ComingSoon
    title="Analytics"
    description="Deep insights — visitors, funnel, cohorts, sources — beyond the Dashboard summary."
    icon={BarChart3} color="blue"
    features={[
      "Website visitors + top pages (server-side, no cookies)",
      "Lead-source attribution",
      "Conversion funnel per campaign",
      "Cohort retention",
      "Google Analytics 4 + Search Console sync",
    ]}
  />
);
